import React, {ReactElement, SVGProps} from 'react'
import {Icon} from './Icon'

export function GitLabLogo(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <Icon {...props}>
      <path fill='#444'
            d='M6.459 1.205a1.344 1.344 0 00-1.271.913l-.003.009-3.373 10.377c0 .009-.007.016-.009.027L.094 17.779a1.911 1.911 0 00.691 2.139l.005.004 14.763 10.727a.75.75 0 00.895-.006l-.002.001 14.765-10.72a1.913 1.913 0 00.692-2.16l.004.014-1.68-5.156a.726.726 0 00-.043-.143l.002.005-3.368-10.367a1.341 1.341 0 00-1.269-.912H25.531c-.585 0-1.082.382-1.252.911l-.003.009-3.208 9.877H10.937L7.724 2.125a1.318 1.318 0 00-1.255-.92h-.002zm-.008 1.894l2.899 8.904H3.566zm19.104 0l2.891 8.904h-5.789zM11.429 13.512h9.149l-2.867 8.824-1.712 5.255zm-7.353.007h5.763l4.115 12.667zm18.091 0h5.768l-9.883 12.669 3.945-12.144zm-19.367.83l9.304 11.929L1.68 18.702a.407.407 0 01-.149-.458l-.001.003zm26.4 0l1.269 3.896a.406.406 0 01-.146.454l-.001.001v.003l-10.427 7.573.033-.047z'/>
    </Icon>
  )
}
